const currentState = {
    calendars: {
        loading: true,
        calendarList: null,
        error: false
    },
    events: {
        loading: true,
        allEvents: null,
        calendarEvents: null,
        error: false
    }
};

const reducer = (state = currentState, action) => {
    const { type, payload } = action;

    switch(type) {
        case 'DECLARE_CALENDARS': {
            const calendars = {...state.calendars};
            
            calendars.loading = false;
            calendars.calendarList = payload;

            return {
                ...state,
                calendars: calendars
            };
        }
        case 'SET_CALENDARS_ERROR': {
            const calendars = {...state.calendars};

            calendars.loading = false;
            calendars.error = true;

            return {
                ...state,
                calendars: calendars
            };
        }
        case 'RESET_CALENDARS': {
            const calendars = {...state.calendars};

            calendars.loading = true;
            calendars.calendarList = null;
            calendars.error = false;

            return {
                ...state,
                calendars: calendars
            };
        }
        case 'DECLARE_ALL_EVENTS': {
            const events = {...state.events};

            events.loading = false;
            events.allEvents = payload;

            if(events.calendarEvents) events.calendarEvents = null;

            return {
                ...state,
                events: events
            };
        }
        case 'DECLARE_CALENDAR_EVENTS': {
            const events = {...state.events};

            events.loading = false;
            events.calendarEvents = payload;

            if(events.allEvents) events.allEvents = null;

            return {
                ...state,
                events: events
            };
        }
        case 'CREATE_EVENT': {
            const events = {...state.events};
            const { allEvents, calendarEvents } = events;
            let afterCreate;

            if(allEvents) {
                afterCreate = [...allEvents];
                afterCreate.unshift(payload);

                events.allEvents = afterCreate;

                return {
                    ...state,
                    events: events
                };
            }else {
                afterCreate = [...calendarEvents];
                afterCreate.unshift(payload);

                events.calendarEvents = afterCreate;

                return {
                    ...state,
                    events: events
                };
            }
        }
        case 'UPDATE_EVENT': {
            const events = {...state.events};
            const { allEvents, calendarEvents } = events;
            let index;

            if(allEvents) {
                index = allEvents.findIndex(event => parseInt(event.event_id) === parseInt(payload.event_id));
                allEvents[index] = payload;

                events.allEvents = allEvents;

                return {
                    ...state,
                    events: events
                };
            }else {
                index = calendarEvents.findIndex(event => parseInt(event.id) === parseInt(payload.id));
                calendarEvents[index] = payload;

                return {
                    ...state,
                    calendarEvents: calendarEvents
                };
            }
        }
        case 'SET_EVENTS_ERROR': {
            const events = {...state.events};

            events.loading = false;
            events.error = true;

            return {
                ...state,
                events: events
            };
        }
        case 'CLEAR_EVENTS_ERROR': {
            const events = {...state.events};

            events.loading = true;
            events.error = false;

            return {
                ...state,
                events: events
            };
        }
        case 'RESET_EVENTS': {
            const events = {...state.events};

            events.loading = true;
            events.allEvents = null;
            events.calendarEvents = null;
            events.error = false;

            return {
                ...state,
                events: events
            };
        }
        default: 
            return state;
    };
};

export default reducer;